// VFX: Particles Form Logo
// Category: intros-outros · Tags: intro, particles, gather, logo, form
// Particles scatter then gather to form a shape/logo.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, random } from "remotion";
import React from "react";

const PARTICLE_COUNT = 140;

// Target shape: a circle/ring (logo placeholder)
function targetPos(i: number, total: number, cx: number, cy: number, r: number) {
  const angle = (i / total) * Math.PI * 2;
  const ring = i % 3;
  const rr = r - ring * 18;
  return { x: cx + Math.cos(angle) * rr, y: cy + Math.sin(angle) * rr };
}

export default function IntroParticlesGatherForm1500Ms() {
  const frame = useCurrentFrame();
  const { width, height, durationInFrames } = useVideoConfig();
  const progress = interpolate(frame, [0, durationInFrames * 0.85], [0, 1], { extrapolateRight: "clamp" });
  const eased = 1 - Math.pow(1 - progress, 3);
  const cx = width / 2;
  const cy = height / 2;
  const radius = Math.min(width, height) * 0.22;

  return (
    <AbsoluteFill style={{ background: "radial-gradient(circle at 50% 50%, #1e1b4b 0%, #0a0e1a 100%)", overflow: "hidden" }}>
      {Array.from({ length: PARTICLE_COUNT }).map((_, i) => {
        const startX = random(`px-${i}`) * width;
        const startY = random(`py-${i}`) * height;
        const target = targetPos(i, PARTICLE_COUNT, cx, cy, radius);
        const x = interpolate(eased, [0, 1], [startX, target.x]);
        const y = interpolate(eased, [0, 1], [startY, target.y]);
        const size = 4 + random(`s-${i}`) * 4;
        const hue = 270 + (i % 30) * 3;
        const opacity = interpolate(progress, [0, 0.1, 1], [0, 1, 1]);
        return (
          <div key={i} style={{
            position: "absolute", left: x, top: y, width: size, height: size,
            borderRadius: "50%",
            background: `hsl(${hue}, 80%, 65%)`,
            boxShadow: `0 0 ${10 * eased}px hsl(${hue}, 80%, 65%)`,
            opacity,
            transform: "translate(-50%,-50%)",
          }} />
        );
      })}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
